const Wallet = () => {
  return <div>Wallet</div>;
};
export default Wallet;
